import { defineMessages } from 'react-intl'

export default defineMessages({
  invoiceId: {
    id: 'containers.CustomerBillingPage.components.InvoiceHeadRow.invoiceId',
    defaultMessage: 'Invoice #',
  },
  netAmount: {
    id: 'containers.CustomerBillingPage.components.InvoiceHeadRow.netAmount',
    defaultMessage: 'Net',
  },
  currency: {
    id: 'containers.CustomerBillingPage.components.InvoiceHeadRow.currency',
    defaultMessage: 'Currency',
  },
  remainder: {
    id: 'containers.CustomerBillingPage.components.InvoiceHeadRow.remainder',
    defaultMessage: 'Remainder',
  },
  orderId: {
    id: 'containers.CustomerBillingPage.components.InvoiceHeadRow.orderId',
    defaultMessage: 'Order #',
  },
  orderName: {
    id: 'containers.CustomerBillingPage.components.InvoiceHeadRow.orderName',
    defaultMessage: 'Order',
  },
  date: {
    id: 'containers.CustomerBillingPage.components.InvoiceHeadRow.date',
    defaultMessage: 'Date',
  },
})
